import { render, staticRenderFns } from "./person_step_4.vue?vue&type=template&id=d0025d9c&"
import script from "./person_step_4.vue?vue&type=script&lang=js&"
export * from "./person_step_4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports